import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { get } from '@eika-infrastruktur/request';

import { SearchParams, useSearchParam } from '@/domain/app';
import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { useSession } from '@components/app/Session';
import { CreditCard } from '@generated-types';

const getCreditCardDetails = async (id: string) => get<CreditCard>(`${KREDITTBANKEN_BASE_URL}/credit-cards/${id}`);

export const useCreditCardDetails = (
    options: Omit<UseQueryOptions<CreditCard>, 'queryKey' | 'queryFn'> = { enabled: true },
) => {
    const session = useSession();
    const id = useSearchParam(SearchParams.CARD_ID);

    return useQuery<CreditCard>({
        queryKey: ['v4', 'credit-cards', id],
        queryFn: () => getCreditCardDetails(id!),
        placeholderData: keepPreviousData,
        ...options,
        enabled: !!session.creditProfile && !!id && options.enabled,
    });
};
